"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aesEncrypt = aesEncrypt;
exports.aeshmacEncrypt = aeshmacEncrypt;
exports.bin2hex = bin2hex;
exports.decryptData = decryptData;
exports.decryptDataV2 = decryptDataV2;
exports.encryptData = encryptData;
exports.rsaEncrypt = rsaEncrypt;
var _nodeForge = _interopRequireDefault(require("node-forge"));
/**
  @param {string} aesKey
  @param {string} message
  @return {ArrayBytes}
 */
function aesEncrypt(aesKey, message) {
  var iv = _nodeForge["default"].random.getBytesSync(16);
  var cipher = _nodeForge["default"].cipher.createCipher("AES-CBC", aesKey);
  cipher.start({
    iv: iv
  });
  cipher.update(_nodeForge["default"].util.createBuffer(message, "utf8"));
  cipher.finish();
  return iv + cipher.output.bytes();
}

/**
  @param {string} hmacKey
  @param {string} message
  @return {ArrayBytes}
 */
function hmac(hmacKey, message) {
  var hmac = _nodeForge["default"].hmac.create();
  hmac.start("sha256", hmacKey);
  hmac.update(message);
  return hmac.digest().bytes();
}

/**
  @param {string} pem
  @param {string} message
  @return {string}
 */
function rsaEncrypt(pem, message) {
  var rsaPub = _nodeForge["default"].pki.publicKeyFromPem(pem);
  var encrypted = rsaPub.encrypt(message, "RSA-OAEP", {
    md: _nodeForge["default"].md.sha256.create()
  });
  return btoa(encrypted);
}

/**
  @param {string} aesKey
  @param {string} hmacKey
  @param {string} message
  @return {string}
 */
function aeshmacEncrypt(aesKey, hmacKey, message) {
  var ct = aesEncrypt(aesKey, message);
  var mac = hmac(hmacKey, ct);
  return btoa(ct + mac);
}

/**
  @param {string} s
  @return {string}
 */
function bin2hex(s) {
  var l = s.length;
  var o = "";
  s += "";
  for (var i = 0; i < l; i++) {
    var n = s.charCodeAt(i).toString(16);
    o += n.length < 2 ? "0" + n : n;
  }
  return o;
}

/**
  @param {string} pem
  @param {string} message
  @return {string}
 */
function encryptData(pem, message) {
  var rsaPub = _nodeForge["default"].pki.publicKeyFromPem(pem);
  var encrypted = rsaPub.encrypt(_nodeForge["default"].util.encodeUtf8(message));
  return _nodeForge["default"].util.encode64(encrypted);
}

/**
  @param {string} data
  @param {string} secretKey
  @return {string}
 */
function decryptData(data, secretKey) {
  var ct = _nodeForge["default"].util.decode64(data);
  var ivSize = 16;
  var iv = ct.slice(0, ivSize);
  var encrypted = ct.slice(ivSize, ct.length - 32);
  // const mac = ct.slice(32);

  var decipher = _nodeForge["default"].cipher.createDecipher("AES-CBC", secretKey.substring(0, 16));
  decipher.start({
    iv: iv
  });
  decipher.update(_nodeForge["default"].util.createBuffer(encrypted));
  return decipher.finish() ? _nodeForge["default"].util.decodeUtf8(decipher.output.data) : null;
}

/**
 @param {string} data
 @param {string} aesKey
 @return {string}
 */
function decryptDataV2(data, aesKey) {
  var ct = _nodeForge["default"].util.decode64(data);
  var ivSize = 16;
  var iv = ct.slice(0, ivSize);
  var encrypted = ct.slice(ivSize, ct.length);
  var decipher = _nodeForge["default"].cipher.createDecipher("AES-CBC", aesKey);
  decipher.start({
    iv: iv
  });
  decipher.update(_nodeForge["default"].util.createBuffer(encrypted));
  return decipher.finish() ? _nodeForge["default"].util.decodeUtf8(decipher.output.data) : null;
}